import { render, staticRenderFns } from "./NuclearDecayViz.vue?vue&type=template&id=95dc6da6&scoped=true"
import script from "./NuclearDecayViz.vue?vue&type=script&lang=js"
export * from "./NuclearDecayViz.vue?vue&type=script&lang=js"
import style0 from "./NuclearDecayViz.vue?vue&type=style&index=0&id=95dc6da6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dc6da6",
  null
  
)

export default component.exports